module.exports = __webpack_public_path__ + "assets/fonts/Roboto-Medium.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/Roboto-Medium.woff
// module id = 687
// module chunks = 0